import {apiUrl} from "../../../setting";

export const getPatientVisitUrl = () => {
    return `${apiUrl}/v2/single-customer-visits`
}